import { useCallback, useState } from "react";
import { ContentDiffViewer } from "../../../../components/diff-viewer";
import { useUser } from "../../../../hook";
import { useDocumentInfo } from "../../hooks/documents/use-document-info";
import { usePublicDocumentContent } from "../../hooks/published-documents/use-public-document-content";
import { Button, Spin } from "antd";

export const EditorPublicVersion = () => {
  const { checkCurrentUser } = useUser();
  const { data } = useDocumentInfo();
  const { differenData, data: contentsData, isLoading } = usePublicDocumentContent();
  const [isVisiblePublish, setIsVisiblePublish] = useState(true);

  const getParentTitle = useCallback(
    (CustomParentId: string) => {
      let parentTitle = "";
      const parentContent = contentsData.find((e: any) => e.CustomId === CustomParentId);
      parentTitle = parentContent?.Title ? parentContent?.Content : "";
      if (!parentContent?.Title) {
        const newParentContent = contentsData.find((e: any) => e.CustomId === parentContent?.CustomParentId);
        parentTitle = newParentContent?.Content || "";
      }
      return parentTitle;
    },
    [contentsData],
  );

  if (isLoading) return <Spin />;
  if (differenData.length === 0) return <></>;


  return (
    <>
      <Button className="my-2" onClick={() => setIsVisiblePublish(!isVisiblePublish)} type="primary">
        {isVisiblePublish ? "Thu gọn" : "Hiển thị"}
      </Button>
      {differenData
        .filter(
          (r: any) =>
            r[1]?.Permissions?.find((e: any) => checkCurrentUser(e.email)) ||
            !data?.isContentPermission ||
            (checkCurrentUser(data?.userEmail || "") &&
              !r[1]?.Content?.includes("<table") &&
              !r[0]?.Content?.includes("<table")),
        )
        .map((row: any, index: any) => {
          const cVersionTitle = getParentTitle(row[1].CustomParentId);
          const pVersionTitle = getParentTitle(row[0].CustomParentId);
          const cVersionSummary = row[1].ContentSummary;
          return (
            <>
              {isVisiblePublish && (
                <ContentDiffViewer
                  oldContent={row[0]?.Content || ""}
                  cVersionTitle={cVersionTitle}
                  pVersionTitle={pVersionTitle}
                  newContent={row[1]?.Content || ""}
                  cVersionSummary={cVersionSummary}
                  id={row[1]?.Id}
                  key={index}
                  index={index}
                />
              )}
            </>
          );
        })}
    </>
  );
};
